
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { getAllPhotoPacks } from '@/data/photo_packs';
import PhotoStudioLanding from '@/components/landing/ImageTools/PhotoStudioLanding';
export default PhotoStudioLanding;
const getStaticProps = async () => ({
    props: { photoPacks: await getAllPhotoPacks() },
});

    async function __Next_Translate__getStaticProps__1a13a29a16a__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/ai-photo-generator',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a13a29a16a__ as getStaticProps }
  